module.exports = __webpack_public_path__ + "img/icon_line.6f262449.svg";